<div (swipeleft)="closeSideNav()" class="sideMenue">
	<div class="navigationSearchContainer">
		<div class="navigationSearchContainerFormField">
			<mat-form-field appearance="fill" class="noHint" color="accent">
				<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_MEDIA_SEARCH_VALUE | translate }}</mat-label>
				<input #sidenavSearchFieldInput [formControl]="navigationFilterCtrl" matInput />
				@if (isFiltered()) {
					<button (click)="navigationFilterCtrl.reset()" aria-label="Clear" color="warn" mat-icon-button matSuffix>
						<mat-icon>close</mat-icon>
					</button>
				}
			</mat-form-field>
		</div>
	</div>

	<div class="categories">
		@for (category of filteredMenuItems(); track category.name) {
			<div
				#categoryDiv
				(click)="category.routeLink ? closeSideNav() : toggleOpenCategory(categoryDiv)"
				[class.open]="isFiltered()"
				[routerLink]="
					activeTrainingSessionIdForRecorder && category.routeLink === '/session-selection/pro-session-selection'
						? '/simrecorder/default/' + activeTrainingSessionIdForRecorder
						: category.routeLink
				"
				class="category"
				routerLinkActive="active"
			>
				<div class="categoryHeader" matRipple>
					<div class="activeSymbol"></div>

					<i
						[class.inRec]="
							activeTrainingSessionIdForRecorder && category.routeLink === '/session-selection/pro-session-selection'
						"
						class="descImage accent {{ category.icon }}"
						style="font-size: 1.4em; width: 32px"
					></i>

					<h3 class="mat-h3 nomargin nopadding accent">
						{{ category.name | translate }}
					</h3>

					@if (category.children?.length) {
						<button (click)="toggleOpenCategory(categoryDiv)" appStopPropagation class="expand" color="accent" mat-icon-button>
							<mat-icon fontIcon="fa-angle-down" fontSet="fas" inline />
						</button>
					}
				</div>

				@if (category.children?.length !== 0) {
					<div class="subCategories">
						@for (subCategory of category.children; track subCategory.name) {
							<div
								#subCategoryDiv
								(click)="!subCategory.routeLink ? toggleOpenCategory(subCategoryDiv) : undefined"
								[class.hasSubSubCategories]="subCategory.children?.length"
								[class.open]="isFiltered()"
								[routerLink]="subCategory.routeLink ? [subCategory.routeLink] : null"
								appStopPropagation
								class="subCategory"
								routerLinkActive="active"
							>
								<div class="subCategoryHeader" matRipple>
									<div class="activeSymbol"></div>
									<div class="nomargin nopadding accent mat-h4 categoryName">
										<div class="subCategoryIcon">
											<i [class]="subCategory.icon"></i>
										</div>
										<div class="sunCategoryName">
											{{ subCategory.name | translate }}
										</div>
									</div>

									@if (subCategory.children?.length) {
										<button
											(click)="toggleOpenCategory(subCategoryDiv)"
											appStopPropagation
											class="expandSub"
											color="accent"
											mat-icon-button
										>
											<mat-icon fontIcon="fa-angle-down" fontSet="fas" inline />
										</button>
									}
								</div>

								<div class="subSubCategories">
									@for (subSubCategory of subCategory.children; track subSubCategory.name) {
										<div
											[routerLinkActive]="'active'"
											[routerLink]="[subSubCategory.routeLink]"
											appStopPropagation
											class="subSubCategory"
											matRipple
										>
											<div class="subSubCategoryActiveSymbol"></div>

											<div class="subSubCategoryIcon">
												<i [class]="subSubCategory.icon"></i>
											</div>

											<div class="subSubCategoryName mat-h4 nomargin accent">
												{{ subSubCategory.name | translate }}
											</div>
										</div>
									}
								</div>
							</div>
						}
					</div>
				}
			</div>
		}
	</div>
</div>

@if (filteredMenuItems().length === 0) {
	<div class="noPagesFoundForFilter">
		<div class="noPagesFoundForFilterText">
			{{ T.APP_SIDE_NAVIGATION_MENU_NO_ITEMS_FOUND | translate }}
		</div>

		<button (click)="navigationFilterCtrl.reset()" color="accent" mat-raised-button>
			{{ T.GLOBAL_TEXT_CLEAR_FILTER | translate }}
		</button>
	</div>
}
